<template>
  <b-col
    cols="12"
    lg="6"
  >
    <b-card>
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <feather-icon
              icon="TagIcon"
              size="20"
              class="text-success mr-2"
            />
            <h4 class="mb-0">
              Cupons Utilizados
            </h4>
          </div>
          <b-badge
            variant="light-success"
            pill
          >
            {{ coupons.length }} cupons
          </b-badge>
        </div>
      </template>

      <b-card-text class="mb-3">
        <small class="text-muted">
          <feather-icon
            icon="InfoIcon"
            size="14"
            class="mr-1"
          />
          Cupons utilizados a partir de 17/02/2024
        </small>
      </b-card-text>

      <div
        v-if="loadingCoupons"
        class="text-center py-5"
      >
        <b-spinner variant="success" />
        <p class="text-muted mt-2">
          Carregando cupons...
        </p>
      </div>

      <div
        v-else-if="coupons.length === 0"
        class="text-center py-5"
      >
        <feather-icon
          icon="TagIcon"
          size="48"
          class="text-muted mb-3"
        />
        <p class="text-muted">
          Nenhum cupom utilizado no período
        </p>
      </div>

      <b-table
        v-else
        :items="coupons"
        :fields="couponFields"
        small
        responsive
        hover
        striped
        class="mb-0"
      >
        <template #cell(name)="data">
          <div class="d-flex align-items-center">
            <div class="avatar bg-light-success mr-2">
              <feather-icon
                icon="TagIcon"
                size="18"
                class="text-success"
              />
            </div>
            <span class="font-weight-bold">{{ data.item.name }}</span>
          </div>
        </template>

        <template #cell(total)="data">
          <b-badge
            variant="light-info"
            pill
          >
            {{ data.item.total }} usos
          </b-badge>
        </template>

        <template #cell(amount)="data">
          <span class="text-success font-weight-bold">
            R$ {{ formatarMoeda(data.item.amount) }}
          </span>
        </template>
      </b-table>
    </b-card>
  </b-col>
</template>

<script>
import {
  BCol, BCard, BCardText, BSpinner, BBadge, BTable,
} from 'bootstrap-vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import { formatarMoeda } from '../services/dashboardService'

export default {
  name: 'CuponsCard',
  components: {
    BCol,
    BCard,
    BCardText,
    BSpinner,
    BBadge,
    BTable,
    FeatherIcon,
  },
  props: {
    coupons: {
      type: Array,
      required: true,
      default: () => [],
    },
    loadingCoupons: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      couponFields: [
        { key: 'name', label: 'Cupom', sortable: true },
        {
          key: 'total', label: 'Usos', sortable: true, class: 'text-center',
        },
        {
          key: 'amount', label: 'Valor Total', sortable: true, class: 'text-right',
        },
      ],
    }
  },
  methods: {
    formatarMoeda(valor) {
      return formatarMoeda(valor)
    },
  },
}
</script>

<style scoped>
.avatar {
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.357rem;
}

.bg-light-success {
  background-color: rgba(40, 199, 111, 0.12) !important;
}
</style>
